import { Component, OnInit } from '@angular/core';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';
import { Services } from '@ibexfusion/core-utils';
import { ChatsService } from '@services/chats/chats.service';
import { DialogService } from '@services/dialog/dialog.service';
import { AddItemsFromList } from '../../user-admin/user-admin-edit/dialogs/add-items-from-list/add-items-from-list.component';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-chats',
  templateUrl: './chats-list.component.html',
  styleUrl: './chats-list.component.scss',
  providers: [PackageService, FrontProfilesService, ChatsService, GroupHasRoleInOrganisationService],
  standalone: false
})
export class ChatsListComponent implements OnInit {
  private packageId: string;
  package: Models.Package;
  chats: Models.Chat[];
  profiles: Models.FrontProfileModel[];
  ids: string[];
  columns = [{ prop: 'title' }, { prop: 'admins', valueCallback: (row: any) => (row?.admins || '').split(',').filter(Boolean).length }];

  constructor(
    private packageService: PackageService, private activatedRoute: ActivatedRoute, private profileService: FrontProfilesService, private chatService: ChatsService,
    private dialogService: DialogService, private connectionService: GroupHasRoleInOrganisationService, private profileConnectionService: GroupHasFrontProfileService,
    private dialog: MatDialog
  ) {
  }

  async ngOnInit() {
    this.packageId = this.activatedRoute.snapshot.params['id'];
    this.package = await this.packageService.get(this.packageId);
    this.profiles = (await this.profileService.find(0, 10000, { packageId: this.packageId, isAnonymous: 0 })).data;
    this.ids = (this.profiles || []).map(a => Services.HashIdService.unhashSingle(a.FrontProfileID));
    this.chats = await this.getChats(this.ids);
  }

  async getChats(ids: string[], batchSize: number = 50) {
    let chats: any = [];
    for (let i = 0; i < ids.length; i += batchSize) {
      const batchIds = ids.slice(i, i + batchSize);
      const query = { $or: batchIds.map(id => ({ chatPartners: { $like: `%${id}` } })) };
      const batchResults = await this.chatService.find(0, 10000, query);
      chats.push(...(batchResults?.data || []));
    }
    chats = chats.filter(c => !(c.title.includes('<->') && c.chatPartners.split(',').filter(Boolean).length === 2));
    return chats;
  }

  async deleteGroup(event: any) {
    const confirmation = await this.dialogService.confirm(`Chatgruppe ${event?.row?.title} wirklich löschen?`);
    if (!confirmation) {
      return;
    }
    await this.chatService.remove(event.row.ChatID);
    this.chats = await this.getChats(this.ids);
  }

  async addAdmin(event: any) {
    const groups = await this.connectionService.find(0, 1000, { roleName: 'chatModuleGroupAdmin', OrganisationID: this.package.OwnerOrganisationID });
    const groupIds = (groups?.data || []).map(g => g.GroupID);
    let profiles: any[] = (await this.profileConnectionService.find(0, 1000, { GroupID: { $in: groupIds } })).data;
    profiles = this.profiles.filter(p => profiles.find(profile => p.FrontProfileID.toString() === profile.ProfileID.toString())).filter(p => !(event?.row?.admins || '').split(',').includes(Services.HashIdService.unhashSingle(p.FrontProfileID)));
    const dialogRef = this.dialog.open(AddItemsFromList, {
      width: '1200px', maxHeight: '90vh',
      data: { availableItems: profiles, columns: [{prop: 'lastName'}, {prop: 'firstName'}, {prop: 'email'}, {prop: 'mobile'}], idField: 'FrontProfileID' }
    });
    const result = await dialogRef.afterClosed().toPromise();
    const admins = (event?.row?.admins || '').split(',').concat((result?.additionalItems || []).map(r => Services.HashIdService.unhashSingle(r))).filter(Boolean).join(',');
    if (admins !== event?.row?.admins) {
      await this.chatService.patch(event.row.ChatID, { admins });
      this.chats = await this.getChats(this.ids);
    }
  }
}
